import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  flex-grow: 1;
  box-sizing: border-box;
  position: relative;
`;

export const JSONContainer = styled.div`
  padding: 10px;
  width: 100%;
`;
